import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';
import {
  P1,
  P1Bold,
  LabelSemibold,
  P2Semibold,
} from 'theme/components/Text.style';

export const Dot = styled.span<{ $color?: string }>`
  display: inline-block;
  width: 6px;
  height: 12px;
  border-radius: 10px;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const Tooltip = styled.div`
  background-color: ${colours.shade[0]};
  border: 2px solid ${colours.neutral[200]};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px;
  box-shadow: 0 20px 90px -15px rgba(0, 0, 0, 0.1);
`;

export const TooltipSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const TooltipTitle = styled(P1Bold)``;

export const TooltipSubtitle = styled(P1)`
  margin-bottom: 8px;
`;

export const TooltipItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TooltipItemLabel = styled(P1)`
  color: ${colours.neutral[500]};
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Legend = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.tablet}) {
    justify-content: flex-start;
    padding-left: 14px;
    gap: 10px;
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const LegendItemText = styled(LabelSemibold)`
  color: ${colours.neutral[900]};
`;

export const LegendVertical = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  width: 60px;
`;

export const LegendVerticalItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  writing-mode: vertical-rl;
  transform: rotate(180deg);

  ${Dot} {
    width: 12px;
    height: 6px;
  }
`;

export const LegendVerticalText = styled(LabelSemibold)`
  color: ${colours.neutral[900]};
`;

export const ChartArea = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ChartAreaBordered = styled(ChartArea)`
  border: 1px solid ${colours.neutral[200]};
  border-radius: 20px;
  padding: 10px;
  overflow: clip;
`;

export const ChartBorder = styled.div`
  border: 1px solid ${colours.neutral[200]};
  border-radius: 20px;
  padding: 1px 10px;
  overflow: clip;
`;

export const HorizontalBarLayout = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 10px;
  row-gap: 10px;
  width: 100%;
`;

export const HorizontalBarLabels = styled.div<{
  $paddingTop: number;
  $paddingBottom: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
  padding-top: ${({ $paddingTop }) => $paddingTop}px;
  padding-bottom: ${({ $paddingBottom }) => $paddingBottom}px;
  flex-shrink: 0;
`;

export const HorizontalBarLabel = styled.span`
  font-size: 13px;
  font-weight: 650;
  color: ${colours.neutral[900]};
  font-family: 'Inter', sans-serif;
  text-align: right;
  max-width: 150px;
  line-height: 1.15;
`;

export const ChartEmptyWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const ChartBlurredBackground = styled.div`
  pointer-events: none;
`;

export const ChartEmptyOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChartEmptyCentered = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
  width: 100%;
`;

export const ChartEmptyCard = styled.div`
  background-color: ${colours.shade[0]};
  border: 2px solid ${colours.neutral[100]};
  border-radius: 40px;
  box-shadow: 0 20px 90px -15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  width: 280px;
  min-width: 180px;
  overflow: clip;
`;

export const ChartEmptyTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 0;
  text-align: center;
  width: 100%;
`;

export const ChartEmptyTitle = styled(P2Semibold)`
  color: ${colours.neutral[900]};
  font-weight: 650;
`;

export const ChartEmptyDescription = styled(P1)`
  color: ${colours.neutral[500]};
`;
